import React from 'react';
import { Container, Paper, Typography, Button, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

import { currentSiteVariant } from '../../utils/siteVariant';

// Після створення запису повертаємо гостя на головну ТОГО лендінгу, з якого
// він прийшов (чоловічий cleanhands.club або жіночий w.cleanhands.club)

export default function BookSuccess() {
  const { t } = useTranslation();
  const landingUrl = currentSiteVariant().landingUrl;
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Stack spacing={2} alignItems="center">
          <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
          <Typography variant="h5">{t('bookSuccess.title')}</Typography>
          <Typography color="text.secondary">
            {t('bookSuccess.text')}
          </Typography>
          <Button variant="contained" href={landingUrl}>
            {t('bookSuccess.backToSite')}
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
